import moment from 'moment'
import Vue from 'vue'

Vue.filter('currency', function(value: number, isCts:boolean = true, local:string='fr-FR', currency:string = 'EUR') {
  return formatCurrency(value,isCts,local,currency);
})

export const formatCurrency = (value: number, isCts:boolean = true, local:string='fr-FR', currency:string = 'EUR') => {  
  if (value || value === 0) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency,
        minimumFractionDigits:0,
        maximumFractionDigits:2
      }).format(value/(isCts?100.0:1))     
  }
}